import { fiflboxApi } from '@/utils/api';

const actions = {
  async createChildMembership({ commit, dispatch }, payload) {
    try {
      await fiflboxApi.v2.postChildMemberships(payload.childMembershipForm);

      return {
        isSuccess: true,
        error: null
      };
    } catch (err) {
      return {
        isSuccess: false,
        error: err
      };
    }
  }
};

export default {
  actions
};
